import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { createContext, useContextSelector } from "@fluentui/react-context-selector";
import { useBoolean } from "@fluentui/react-hooks";
const Context = createContext({});
const Provider = Context.Provider;
const useProgressionScorecardContext = (selector) => useContextSelector(Context, selector);
const ProgressionScorecardProvider = ({
  featureId,
  openCreatePanel,
  children
}) => {
  const [selectedAnalysisGroupId, setSelectedAnalysisGroupId] = React.useState("");
  const [selectedAnalysisTemplateId, setSelectedAnalysisTemplateId] = React.useState("");
  const [isPanelOpen, { setTrue: openPanel, setFalse: dismissPanel }] = useBoolean(!!openCreatePanel);
  const [isValidationErrorOpen, { setTrue: openErrorPanel, setFalse: dismissErrorPanel }] = useBoolean(false);
  const openPanelWithSelection = React.useCallback(
    (analysisGroupId = "") => {
      setSelectedAnalysisGroupId(analysisGroupId);
      openPanel();
    },
    [openPanel, setSelectedAnalysisGroupId]
  );
  const clearAndDismissPanel = React.useCallback(() => {
    setSelectedAnalysisGroupId("");
    dismissPanel();
  }, [dismissPanel, setSelectedAnalysisGroupId]);
  const openErrorPanelWithSelection = React.useCallback(
    (analysisGroupId, analysisTemplateId) => {
      setSelectedAnalysisGroupId(analysisGroupId);
      setSelectedAnalysisTemplateId(analysisTemplateId);
      openErrorPanel();
    },
    [openErrorPanel, setSelectedAnalysisGroupId]
  );
  const clearAndDismissErrorPanel = React.useCallback(() => {
    setSelectedAnalysisGroupId("");
    setSelectedAnalysisTemplateId("");
    dismissErrorPanel();
  }, [dismissErrorPanel, setSelectedAnalysisGroupId]);
  return /* @__PURE__ */ jsx(
    Provider,
    {
      value: {
        featureId,
        isPanelOpen,
        isValidationErrorOpen,
        selectedAnalysisGroupId,
        selectedAnalysisTemplateId,
        setSelectedAnalysisGroupId,
        openPanel: openPanelWithSelection,
        dismissPanel: clearAndDismissPanel,
        openErrorPanel: openErrorPanelWithSelection,
        dismissErrorPanel: clearAndDismissErrorPanel
      },
      children
    }
  );
};
export {
  ProgressionScorecardProvider,
  useProgressionScorecardContext
};
//# sourceMappingURL=Provider.js.map
